import {ClimateVariable} from '../../../types/api/assets';

// TODO: mock-up only, labels and descriptions taken from the current climate change endpoint
export const climateVariablesMock: ClimateVariable[] = [
  {
    "name": "tas",
    "label": "Media mensile della temperatura media giornaliera",
    "short_label": "Temperatura media",
    "description": "Media mensile della media giornaliera della temperatura dell'aria vicino alla supeficie (2 metri)",
    "um": "°C",
    "hazards": [
      {"code": "LIGHTNING", "description": null},
      {"code": "RAIN", "description": null},
      {"code": "STORM", "description": null},
      {"code": "DROUGHT", "description": null}
    ]
  },
  {
    "name": "ds",
    "label": "Giorni secchi consecutivi annui",
    "short_label": "Giorni secchi consecutivi",
    "description": "Massimo annuo di giorni consecutivi nei quali le precipitazioni cumulate sono inferiori ad 1 mm",
    "um": "giorni",
    "hazards": [
      {"code": "DROUGHT", "description": null}
    ]
  },
  {
    "name": "hdd",
    "label": "Gradi giorno di riscaldamento annui",
    "short_label": "Gradi giorno di riscaldamento",
    "description": "Consumo energetico annuo per riscaldare il deficit di temperatura inferiore a 15.5 °C",
    "um": "gradi-giorno",
    "hazards": [
      {"code": "SNOW", "description": null}
    ]
  },
  {
    "name": "cdd",
    "label": "Gradi giorno di raffrescamento annui",
    "short_label": "Gradi giorno di raffrescamento",
    "description": "Consumo energetico annuo per reaffrescare l'eccesso di temperatura superiore a 22 °C",
    "um": "gradi-giorno",
    "hazards": [
      {"code": "DROUGHT", "description": null}
    ]
  },
  {
    "name": "tx40",
    "label": "Conteggio mensile dei giorni con temperatura massima > 40 °C",
    "short_label": "Giorni con temperatura massima > 40 °C",
    "description": "Conteggio mensile dei giorni con temperatura massima dell'aria vicino alla supeficie (2 metri)  superiore a 40 °C",
    "um": "giorni",
    "hazards": [
      {"code": "HAILSTORM", "description": null},
      {"code": "DROUGHT", "description": null}
    ]
  },
  {
    "name": "pr",
    "label": "Media mensile delle precipitazioni giornaliere cumulate",
    "short_label": "Precipitazioni",
    "description": "Media mensile delle precipitazioni giornaliere di acqua liquida equivalente in tutte le fasi",
    "um": "mm",
    "hazards": [
      {"code": "FLOOD", "description": null},
      {"code": "LANDSLIDE", "description": null}
    ]
  },
  {
    "name": "sfcWind",
    "label": "Media mensile della velocità media giornaliera del vento",
    "short_label": "Velocità del vento",
    "description": "Media mensile della velocità media giornaliera del vento vicino alla superficie (10 metri)",
    "um": "m/s",
    "hazards": [
      {"code": "COASTALFLOOD", "description": null},
      {"code": "WIND", "description": null},
      {"code": "WINDSTORM", "description": null},
      {"code": "CYCLONE", "description": null}
    ]
  },
  {
    "name": "PM25",
    "label": "Concentrazione superficiale di PM2.5",
    "short_label": "PM2.5",
    "description": "Concentrazione superficiale di PM2.5",
    "um": "ug/m^3",
    "hazards": []
  },
  {
    "name": "co2",
    "label": "Emissioni di CO2",
    "short_label": "CO2",
    "description": "Emissioni di CO2 di origine antropica",
    "um": "kg/m^2",
    "hazards": []
  },
  {
    "name": "slr",
    "label": "Innalzamento del livello del mare",
    "short_label": "Livello del mare",
    "description": "Innalzamento del livello del mare",
    "um": "m",
    "hazards": [
      {"code": "COASTALFLOOD", "description": null}
    ]
  }
]
